import type { RenderScene } from './renderingAdapter';

function samePropertiesExcept<T extends object>(first: T, second: T, excluded: keyof T): boolean {
  const firstKeys = (Object.keys(first) as (keyof T)[]).filter((key) => key !== excluded);
  const secondKeys = (Object.keys(second) as (keyof T)[]).filter((key) => key !== excluded);
  return (
    firstKeys.length === secondKeys.length &&
    firstKeys.every((key) => Object.hasOwn(second, key) && first[key] === second[key])
  );
}

/** Ignore authored changes that cannot affect rendering, without scanning data or deriving a plan. */
export function scenesDifferOnlyInHiddenLabels(previous: RenderScene, next: RenderScene): boolean {
  return (
    samePropertiesExcept(previous, next, 'layers') &&
    previous.layers.length === next.layers.length &&
    previous.layers.every((layer, index) => {
      const candidate = next.layers[index];
      return (
        candidate !== undefined &&
        (layer === candidate ||
          (!layer.labels.enabled &&
            !candidate.labels.enabled &&
            samePropertiesExcept(layer, candidate, 'labels')))
      );
    })
  );
}
